import { api } from '@smena/ui';

/** Откуда пришло значение поля. 'none' - не задано нигде, порт работает в деградации. */
export type LlmFieldSource = 'db' | 'env' | 'default' | 'none';

export type LlmField =
  | 'baseUrl'
  | 'apiKey'
  | 'model'
  | 'timeoutMs'
  | 'rateLimitRpm'
  | 'thinking'
  | 'proxyUrl'
  | 'embedBaseUrl'
  | 'embedApiKey'
  | 'embedModel'
  | 'embedDim';

export interface LlmSettingsView {
  chat: {
    baseUrl: string | null;
    model: string | null;
    keyMasked: string | null;
    timeoutMs: number;
    rateLimitRpm: number;
    thinking: string | null;
    proxyUrl: string | null;
    configured: boolean;
  };
  embed: {
    baseUrl: string | null;
    model: string | null;
    keyMasked: string | null;
    dim: number;
    configured: boolean;
  };
  sources: Record<LlmField, LlmFieldSource>;
  fixedEmbedDim: number;
  envOverrides: { mock: boolean; stub: boolean };
  runtime: { chatModel: string | null; embedModel: string };
  kb: { chunks: number; stale: number; byModel: Array<{ model: string | null; count: number }> };
  updatedAt: string | null;
  updatedByEmail: string | null;
}

export interface SaveLlmInput {
  baseUrl?: string;
  apiKey?: string;
  model?: string;
  timeoutMs?: number;
  rateLimitRpm?: number;
  thinking?: string;
  proxyUrl?: string;
  embedBaseUrl?: string;
  embedApiKey?: string;
  embedModel?: string;
  clearApiKey?: boolean;
  clearEmbedApiKey?: boolean;
}

export interface ProbeResult {
  ok: boolean;
  status: number | null;
  ms: number;
  error: string | null;
  detail: string | null;
}

export interface ReindexResult {
  total: number;
  updated: number;
  failed: number;
  model: string;
  ms: number;
}

export function fetchLlmSettings(): Promise<LlmSettingsView> {
  return api<LlmSettingsView>('/api/admin/llm');
}

// `json:`, а не `body: JSON.stringify(...)` - хелпер ставит Content-Type только в первом
// варианте, иначе Nest получит text/plain и разберёт тело как пустое.
export function saveLlmSettings(input: SaveLlmInput): Promise<LlmSettingsView> {
  return api<LlmSettingsView>('/api/admin/llm', { method: 'PUT', json: input });
}

/**
 * Проверка идёт на сервере: из браузера мешает CORS, и ключ пришлось бы держать во фронте.
 * Незаполненные поля сервер добирает из действующего конфига - поэтому проверить можно
 * и то, что ещё не сохранено.
 */
export function testLlm(input: {
  kind: 'chat' | 'embed';
  baseUrl?: string;
  apiKey?: string;
  model?: string;
  proxyUrl?: string;
}): Promise<ProbeResult> {
  return api<ProbeResult>('/api/admin/llm/test', { method: 'POST', json: input });
}

export function reindexKb(): Promise<ReindexResult> {
  return api<ReindexResult>('/api/admin/llm/reindex-kb', { method: 'POST' });
}

const SOURCE_LABEL: Record<LlmFieldSource, string> = {
  db: 'из админки',
  env: 'из .env',
  default: 'по умолчанию',
  none: 'не задано',
};

export function sourceLabel(s: LlmFieldSource | undefined): string {
  return SOURCE_LABEL[s ?? 'none'];
}
